import type {ReactAction} from '@netx/core/bootstrap';
import {faSearch} from '@netx/core-icons';
import {canFindReplaceCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Find and replace cart asset attribute values
 * @param params
 * @returns Action
 */
export const cartActionFindReplace = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-find-replace',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.FIND_REPLACE),
	enableTest: canFindReplaceCurrentCart,
	icon: faSearch,
	get label() {
		return CART_CURRENT_ACTION_LABELS.FIND_REPLACE;
	},
	...params,
});

export default cartActionFindReplace;
